import React from 'react';
import { useTranslation } from 'react-i18next';
import './ErrorMessage.css';

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
  onClose?: () => void;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, onRetry, onClose }) => {
  const { t } = useTranslation('common');
  
  return (
    <div className="error-message-container">
      <div className="error-icon">⚠️</div>
      <p className="error-text">{message}</p>
      <div className="error-actions">
        {onRetry && (
          <button className="error-retry-button" onClick={onRetry}>
            {t('actions.retry')}
          </button>
        )}
        {onClose && (
          <button className="error-close-button" onClick={onClose}>
            {t('actions.close')}
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;

